// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"2c5b2a0f","628":"de4662ff","787":"43cfbd61"}[chunkId] + ".chunk.js";
};